import { fetchTrain } from '@/api/service'
const getTrain = (context) => {
  fetchTrain().then((response) => {
    context.commit('TRAIN_UPDATED', response)
  })
}

export default {
  getTrain
}
